export default {
  namespaced: true,
  installation_components: {
    next: "Next",
    previous: "Previous",
    no_options_found: "No options found",
  },
};
